<template>
    <div>
        <template v-if="!loading && svgRendered">
            <Card title="Estado de las Plazas">
                <div
                    class="tw:flex tw:items-center tw:gap-2 tw:mb-4 tw:text-sm tw:text-gray-600"
                    v-if="plaza_abonado"
                >
                    <span>La plaza seleccionada del abonado esta de color:</span>
                    <div
                        class="tw:w-5 tw:h-5 tw:rounded tw:border tw:border-gray-300 tw:inline-block"
                        :style="{ backgroundColor: '#fdf749' }"
                        title="#fdf749"
                    ></div>
                </div>
                <div>
                    <div v-if="tipo_svg === 1">
                        <SvgPanZoom
                            class="tw:w-full"
                            :zoomEnabled="true"
                            :controlIconsEnabled="false"
                            :fit="true"
                            :center="true"
                            :mouseWheelZoomEnabled="false"
                            :zoomScaleSensitivity="2"
                            :dblClickZoomEnabled="false"
                            :preventMouseEventsDefault="false"
                            @svgpanzoom="registerSvgPanZoom"
                        >
                            <svg v-html="svg_loaded"/>
                        </SvgPanZoom>
                    </div>
                    <LeafletComponent
                        v-else
                        :svgRendered="svgRendered"
                        :originalColor="originalColor"
                        @isPanning="(e) => isPanning = e"
                    />
                </div>
            </Card>
        </template>
        <template v-else>
            <div class="tw:space-y-4 tw:animate-pulse">
                <SkeletonItem height="tw:h-4" customClass="tw:w-40 tw:rounded" />
                <div class="tw:flex tw:items-center tw:gap-2">
                    <SkeletonItem height="tw:h-3" customClass="tw:w-56" />
                    <SkeletonItem height="tw:h-5" customClass="tw:w-5 tw:rounded" />
                </div>
                <div class="tw:border tw:border-gray-200 tw:rounded-lg tw:bg-gray-50 tw:flex tw:items-center tw:justify-center" style="height: 500px">
                    <div class="tw:flex tw:flex-col tw:items-center tw:gap-3">
                        <SkeletonItem height="tw:h-16" customClass="tw:w-16 tw:rounded-full tw:bg-gray-200" />
                        <SkeletonItem height="tw:h-3" customClass="tw:w-36 tw:bg-gray-200" />
                        <SkeletonItem height="tw:h-3" customClass="tw:w-24 tw:bg-gray-200" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import Card from '@/modules/admin/ui/Card.vue';
    import { SkeletonItem } from '@/modules/admin/ui/skeleton';

    import { useCambiarPlaza } from '@/composables/admin/abonados/useCambiarPlaza';

    const props = defineProps({
        tipo_svg: {
            type: Number
        },
        zona: {
            required: false
        },
        plaza_abonado: {
            type: Object
        }
    });

    const emit = defineEmits(['cambiarPlaza']);

    const tipoSvgRef = computed(() => props.tipo_svg);
    const zonaRef = computed(() => props.zona);
    const plazaAbonadoRef = computed(() => props.plaza_abonado);

    const {
        // State
        svg_loaded,
        loading,
        svgRendered,
        isPanning,

        // Color constants
        originalColor,

        // Methods
        registerSvgPanZoom
    } = useCambiarPlaza({
        tipo_svg: tipoSvgRef,
        zona: zonaRef,
        plaza_abonado: plazaAbonadoRef,
        onCambiarPlaza: (...args) => emit('cambiarPlaza', ...args)
    });
</script>
